import { RouteRecordRaw } from 'vue-router'

const RefHome = () => import('./pages/RefHome.vue')
const RefSchemaNew = () => import('./pages/RefSchemaNew.vue')
const RefSchemaEdit = () => import('./pages/RefSchemaEdit.vue')
const RefSchemaDetails = () => import('./pages/RefSchemaDetails.vue')
const ContentNew = () => import('./pages/ContentNew.vue')
const ContentEdit = () => import('./pages/ContentEdit.vue')
const ContentDetails = () => import('./pages/ContentDetails.vue')
const SubjectNew = () => import('./pages/SubjectNew.vue')
const SubjectEdit = () => import('./pages/SubjectEdit.vue')
const SubjectDetails = () => import('./pages/SubjectDetails.vue')
const ContentMapNew = () => import('./pages/ContentMapNew.vue')
const ContentMapEdit = () => import('./pages/ContentMapEdit.vue')
const ContentMapDetails = () => import('./pages/ContentMapDetails.vue')

export const refRoutes: RouteRecordRaw[] = [
  {
    path: '/cms',
    name: 'refHome',
    component: RefHome,
    props: true,
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/content/new',
    name: 'contentNew',
    component: ContentNew,
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/content/:contentId',
    name: 'contentDetails',
    component: ContentDetails,
    props: (route) => ({
      contentId: Number(route.params.contentId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/content/:contentId/edit',
    name: 'contentEdit',
    component: ContentEdit,
    props: (route) => ({
      contentId: Number(route.params.contentId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/subjects/new',
    name: 'subjectNew',
    component: SubjectNew,
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/subjects/:subjectId',
    name: 'subjectDetails',
    component: SubjectDetails,
    props: (route) => ({
      subjectId: Number(route.params.subjectId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/subjects/:subjectId/edit',
    name: 'subjectEdit',
    component: SubjectEdit,
    props: (route) => ({
      subjectId: Number(route.params.subjectId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/schemas/new',
    name: 'schemaNew',
    component: RefSchemaNew,
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/schemas/:schemaId',
    name: 'schemaDetails',
    component: RefSchemaDetails,
    props: (route) => ({
      schemaId: Number(route.params.schemaId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/schemas/:schemaId/edit',
    name: 'schemaEdit',
    component: RefSchemaEdit,
    props: (route) => ({
      schemaId: Number(route.params.schemaId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/maps/new',
    name: 'contentMapNew',
    component: ContentMapNew,
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/maps/:mapId',
    name: 'contentMapDetails',
    component: ContentMapDetails,
    props: (route) => ({
      mapId: Number(route.params.mapId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
  {
    path: '/cms/maps/:mapId/edit',
    name: 'contentMapEdit',
    component: ContentMapEdit,
    props: (route) => ({
      mapId: Number(route.params.mapId),
    }),
    meta: {
      header: true,
      requiresAuth: true,
    },
  },
]
